// @ts-nocheck
import { setDocument } from "@store/Framework/Services/QuoteService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type SetRfqDetailsDocumentsParameter = {
    fileStream: string;
    fileName: string;
    orderNumber: string;
    onSuccess: () => void;
};
type Props = {
    apiParameter: SetRfqDetailsDocumentsParameter;
    apiResult: any;
};

type HandlerType = Handler<SetRfqDetailsDocumentsParameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await setDocument(props.apiParameter);
};

export const DispatchCompleteGetRfqDetailsDocuments: HandlerType = props => {
    const { dispatch, apiResult } = props;
    dispatch({
        type: "Store/Pages/RfqQuoteDetails/SetRfqDetailsAddDocuments",
        docName: apiResult.FileName,
    });
    if (apiResult.ResponseMessage) {
        dispatch({
            type: "Store/Pages/RfqQuoteDetails/SetRfqDetailsDocumentUploadMsg",
            documentUploadMsg: apiResult.ResponseMessage,
        });
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess();
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteGetRfqDetailsDocuments,
    ExecuteOnSuccessCallback,
];

const setQuoteDetailsDocuments = createHandlerChainRunner(chain, "SetQuoteDetailsDocuments");
export default setQuoteDetailsDocuments;
